<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('assitive_device_management.bill_generate')}} {{ $t('globalTrans.entry') }}</h4>
          </template>
          <template v-slot:headerAction>
            <router-link to="bill-generate" :class="'btn btn-primary text-light'">{{  $t('assitive_device_management.bill_generate') }} {{ $t('globalTrans.list') }}</router-link>
          </template>
          <template v-slot:body>
            <b-row>
                <b-col xl="12" lg="12" sm="12">
                    <b-overlay :show="loading" rounded="sm">
                    <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                        <b-form @submit.prevent="handleSubmit(register)" @reset.prevent="reset">
                            <b-row>
                              <b-col lg="4" md="4" sm="4" xs="4">
                                <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="fiscal_year_id"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('globalTrans.fiscal_year')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="data.fiscal_year_id"
                                    :options="fiscalYearList"
                                    id="fiscal_year_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                    </b-form-group>
                                </ValidationProvider>
                              </b-col>
                              <b-col lg="4" md="4" sm="4" xs="4">
                                <ValidationProvider name="Supplier Name" vid="supplier_info_id" rules='required|min_value:1'>
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="4"
                                      label-for="supplier_info_id"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{ $t('assitive_device_management.supplier_name')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                        plain
                                        v-model="data.supplier_info_id"
                                        :options="supplierInfoList"
                                        id="supplier_info_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                      <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                      </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                      {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                                </ValidationProvider>
                              </b-col>
                              <b-col lg="4" md="4" sm="4" xs="4">
                                <ValidationProvider name="PO No." vid="p_o_no" rules="required|min_value:1">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="4"
                                      label-for="p_o_no"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('assitive_device_management.p_o_no')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                        plain
                                        v-model="data.p_o_no"
                                        :options="purchaseList"
                                        id="p_o_no"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        @change="getDeviceList(data.p_o_no)"
                                    >
                                      <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                      </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                      {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                                </ValidationProvider>
                              </b-col>
                            </b-row>
<!--                            <b-row class="mb-4 mt-2" style="border: 1px solid black;padding-top: 23px;padding-bottom: 27px;}">-->
                            <div class="table-responsive">
                            <table class="table table-bordered table-sm mb-4">
                                <thead style="background-color: #44B2D8;">
                                <tr>
                                    <th>{{$t('globalTrans.sl_no')}}</th>
                                    <th>{{ $t('assitive_device_management.assistive_device_name')}}</th>
                                    <th class="text-right">{{ $t('assitive_device_management.purchase_quantity')}}</th>
                                    <th class="text-right">{{ $t('assitive_device_management.recieved_quantity')}}</th>
                                    <th class="text-right">{{ $t('assitive_device_management.unit_price')}}</th>
                                    <th width="25%" class="text-right">{{ $t('assitive_device_management.total_price')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                              <template v-if="AddmoreArray.length">
                                <tr v-for="(item,index) in AddmoreArray" :key="index" >
                                    <td style="color:black;">{{$n(index + 1)}}</td>
                                    <td style="color:black;" class="text-right">
                                    {{ currentLocale === 'en' ? item.device_name_en : item.device_name_bn }}
                                    </td>
                                    <td style="color:black;" class="text-right">
                                      {{ $n(item.purchased_quantity) }}
                                    </td>
                                    <td style="color:black;" class="text-right">
                                      {{ $n(item.received_quantity) }}
                                    </td>
                                    <td style="color:black;" class="text-right">
                                      {{ $n(item.unit_price) }}
                                    </td>
                                    <td style="color:black;" class="text-right">
                                      {{ $n(item.total_price) }}
                                    </td>
                                </tr>
                              </template>
                              <template v-else>
                                <tr>
                                  <td align="center" colspan="7">{{ $t('globalTrans.noDataFound') }}</td>
                                </tr>
                              </template>
                            </tbody>
                              <tfoot>
                                <tr>
                                  <th colspan="5" class="text-right">{{ $t('globalTrans.total') }}</th>
                                  <th class="text-right">{{ $n(totalPrice) }}</th>
                                </tr>
                              <tr>
                                <th colspan="5" class="text-right">
                                  {{ $t('assitive_device_management.vat_and_tax') }}
                                  <b-button v-if="totalPrice  > 0" :title="$t('assitive_device_management.add_vat_and_tax')"
                                  variant="text-info" class="border-default m-0" size="sm" @click="showVatInput()">
                                  <i class="ri-add-circle-fill" v-if="vatAndTax <= 0"></i>
                                  <i class="ri-edit-circle-fill" v-else></i>
                                  </b-button>
                                  </th>
                                <th class="text-right">
                                  <span v-if="showVatTax">{{ $n(vatAndTax) }}</span>
                                  <b-button
                                  v-show="showVatTaxInput"
                                  :title="$t('assitive_device_management.add_vat_and_tax')"
                                  variant=" iq-bg-success border-default m-0" size="sm"
                                  @click="saveVatInput()"><i class="ri-save-fill"></i>
                                  </b-button>
                                  <input v-show="showVatTaxInput" type="number" v-model="vatAndTax" name="vat_tax" id="vat_tax" @change="calGrandWVat(vatAndTax)">
                                </th>
                              </tr>
                              <tr>
                                <th colspan="5" class="text-right">{{ $t('sitePreference.grandTotal') }}</th>
                                <th class="text-right">{{ $n(grandTotalPrice) }}</th>
                              </tr>
                              </tfoot>
                            </table>
                            </div>
<!--                            </b-row>-->
                            <b-row>
                              <b-col lg="6" md="6" sm="6" xs="6">
                                  <ValidationProvider name="Bill Process Date" vid="bill_process_date" rules="required">
                                      <b-form-group
                                          class="row"
                                          label-cols-sm="4"
                                          label-for="bill_process_date"
                                          slot-scope="{ valid, errors }"
                                      >
                                      <template v-slot:label>
                                          {{$t('assitive_device_management.recieved_date')}} <span class="text-danger">*</span>
                                      </template>
                                      <flat-pickr class="form-control"
                                          v-model="data.bill_process_date"
                                          id="to_date"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                          >
                                      </flat-pickr>
                                        <div class="invalid-feedback" :class="(errors.length ? 'd-block' : '')">
                                          {{ errors[0] }}
                                        </div>
                                      </b-form-group>
                                  </ValidationProvider>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col lg="6" md="6" sm="6" xs="6">
                                  <ValidationProvider name="Description (En)" vid="description_en">
                                      <b-form-group
                                          class="row"
                                          label-cols-sm="4"
                                          label-for="description_en"
                                          slot-scope="{ valid, errors }"
                                      >
                                      <template v-slot:label>
                                          {{$t('globalTrans.description_en')}}
                                      </template>
                                      <b-form-textarea
                                      id="description_en"
                                      v-model="data.description_en"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                      ></b-form-textarea>
                                      <div class="invalid-feedback">
                                      {{ errors[0] }}
                                      </div>
                                      </b-form-group>
                                  </ValidationProvider>
                              </b-col>
                              <b-col lg="6" md="6" sm="6" xs="6">
                                <ValidationProvider name="Description (Bn)" vid="description_bn">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="4"
                                      label-for="description_bn"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('globalTrans.description_bn')}}
                                    </template>
                                    <b-form-textarea
                                        id="description_bn"
                                        v-model="data.description_bn"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-textarea>
                                    <div class="invalid-feedback">
                                      {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                                </ValidationProvider>
                              </b-col>
                            </b-row>
                            <div class="row">
                            <div class="col-sm-3"></div>
                            <div class="col text-right">
                                <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                &nbsp;
                                <router-link to="bill-generate"><b-button variant="danger" class="mr-1">{{ $t('globalTrans.cancel') }}</b-button></router-link>
                            </div>
                            </div>
                        </b-form>
                    </ValidationObserver>
                    </b-overlay>
                </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import {
  BillGenerateStore,
  purchaseMemoList, BillGenerateDeviceList
} from '../../api/routes'
import { helpers } from '@/mixins/helper-functions'

export default {
    name: 'FormLayout',
    props: ['id', 'item'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
      this.getPurchaseMemoList()
    },
    mounted () {
        core.index()
        this.data = Object.assign({}, this.data, {
          bill_process_date: helpers.currentDate()
        })
    },
    data () {
        return {
            saveBtnName: this.$t('globalTrans.save'),
            loading: false,
            showVatTax: true,
            showVatTaxInput: false,
            data: {
                fiscal_year_id: 0,
                supplier_info_id: 0,
                p_o_no: 0,
                bill_process_date: '',
                description_en: '',
                description_bn: '',
                vat_tax: 0,
                total_price: 0,
                grand_total_price: 0,
                devices: []
            },
            AddmoreArray: [],
            purchaseList: [],
            purchaseMemoListAll: [],
            challanNoListAll: [],
            challanNoList: [],
            isLoading: false,
            supplierInfoList: [],
            vatAndTax: 0,
            grandTotalPrice: 0,
            totalPrice: 0
        }
    },
    computed: {
      currentLocale () {
        return this.$i18n.locale
      },
      fiscalYearList: function () {
        return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
      },
      yearList () {
        return helpers.getYearList()
      },
      assistiveDeviceList: function () {
        return this.$store.state.AwarenessEventService.commonObj.assistiveDeviceList.filter(item => item.status === 1)
      },
      orgList: function () {
          return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
      },
      fiscalYear: function () {
          const objectData = this.$store.state.commonObj.fiscalYearList
          return objectData.map((obj, key) => {
              if (this.$i18n.locale === 'bn') {
                  return { value: obj.value, text: obj.text_bn }
              } else {
                  return { value: obj.value, text: obj.text_en }
              }
          })
      },
      idscCenterList: function () {
        return this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.status === 1)
      }
    },
    watch: {
      'data.fiscal_year_id': function (newVal) {
        this.AddmoreArray = []
        if (newVal) {
          this.supplierInfoList = this.getSupplierInfoList(newVal)
        } else {
          this.supplierInfoList = []
        }
      },
      'data.supplier_info_id': function (newVal) {
        this.AddmoreArray = []
        if (newVal) {
          this.purchaseList = this.getMemoList(newVal)
        } else {
          this.purchaseList = []
        }
      }
    },
    methods: {
        async register () {
            this.loading = true
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            const loadinState = { loading: false, listReload: true }
            this.data.devices = []
            this.data.devices = this.AddmoreArray
            this.data.vat_tax = this.vatAndTax
            this.data.total_price = this.totalPrice
            this.data.grand_total_price = this.grandTotalPrice
            const result = await RestApi.postData(awarenessEventServiceBaseUrl, BillGenerateStore, this.data)
            this.$store.dispatch('mutateCommonProperties', loadinState)
            if (result.success) {
                this.data = {
                  fiscal_year_id: 0,
                  supplier_info_id: '',
                  p_o_no: '',
                  bill_process_date: '',
                  description_en: '',
                  description_bn: '',
                  vat_tax: 0,
                  total_price: 0,
                  grand_total_price: 0,
                  devices: []
                }
                this.$nextTick(() => {
                  this.$refs.form.reset()
                })
                this.loading = false
                this.$store.dispatch('HospitalDisabilityService/mutateCommonObj', { hasDropdownLoaded: false })
                this.$toast.success({
                  title: this.$t('globalTrans.success'),
                  message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                  color: '#156b1f'
                })
                this.$router.push('bill-generate')
            } else {
                this.loading = false
                this.$refs.form.setErrors(result.errors)
            }
        },
      async getPurchaseMemoList () {
        this.loading = true
        const response = await RestApi.getData(awarenessEventServiceBaseUrl, purchaseMemoList)
        if (response.success) {
          this.purchaseMemoListAll = response.data.map(item => {
            const customItem = {
              value: item.value, text: this.$i18n.locale === 'bn' ? helpers.convertEnglishToBanglaNumber(item.text_bn) : item.text_en
            }
            return Object.assign({}, item, customItem)
          })
            this.data = Object.assign({}, this.data, {
                fiscal_year_id: this.$store.state.currentFiscalYearId
            })
        } else {
          this.purchaseMemoListAll = []
        }
        this.loading = false
      },
      getMemoList (supplierInfoId) {
        let purchaseMemoList = this.purchaseMemoListAll
        if (supplierInfoId) {
          purchaseMemoList = purchaseMemoList.filter(item => item.fiscal_year_id === parseInt(this.data.fiscal_year_id) && item.supplier_info_id === parseInt(supplierInfoId))
        }
        return purchaseMemoList
      },
      getSupplierInfoList (fiscalYearId = null) {
        let supplierInfoList = this.$store.state.AwarenessEventService.commonObj.supplierInfoList.filter(item => item.status === 1)
        supplierInfoList = supplierInfoList.filter(item => {
          const purchaseMemoListItem = this.purchaseMemoListAll.find(obj => obj.supplier_info_id === item.value)
          if (purchaseMemoListItem !== undefined) {
            return item
          }
        })
        return supplierInfoList
      },
      async getDeviceList (purchaseMemoNo) {
        this.AddmoreArray = []
        this.loading = true
        const result = await RestApi.getData(awarenessEventServiceBaseUrl, BillGenerateDeviceList + '/' + purchaseMemoNo)
        if (result.success) {
          this.AddmoreArray = this.getCustomizedDeviceList(result.data)
          this.totalPrice = this.getTotalPrice(result.data)
          this.grandTotalPrice = this.getTotalPrice(result.data)
        } else {
          this.AddmoreArray = []
          this.totalPrice = 0
          this.grandTotalPrice = 0
        }
        this.loading = false
      },
      getCustomizedDeviceList (data) {
        return data.map(deviceItem => {
          const device = this.assistiveDeviceList.find(obj => obj.value === deviceItem.assistive_device_id)
          const deviceItemCustom = {
            device_name_en: device?.text_en,
            device_name_bn: device?.text_bn
          }
          return Object.assign({}, deviceItem, deviceItemCustom)
        })
      },
      getTotalPrice (data) {
        let totalPrice = 0
        data.forEach(item => {
          totalPrice += item.total_price
        })
        return totalPrice
      },
      showVatInput () {
        if (this.totalPrice > 0) {
          this.showVatTax = false
          this.showVatTaxInput = true
        }
      },
      saveVatInput () {
        this.showVatTax = true
        this.showVatTaxInput = false
      },
      calGrandWVat (value) {
        let tPrice = this.totalPrice
        // if (value > 0) {
          tPrice += parseInt(value)
          this.grandTotalPrice = tPrice
        // } else {
        //   this.vatAndTax = 0
        // }
      }
    }
}
</script>

<style>
body {
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
}

table, th, td {
  border: solid 1px #000;
  padding: 10px;
  color: black;
}

table {
    border-collapse:collapse;
    caption-side:bottom;
}

caption {
  font-size: 16px;
  font-weight: bold;
  padding-top: 5px;
}
.toast-title {
  color:white;
}
.toast-message {
    color:white;
}
.is-valid {
        padding-right: 0px!important;
}
</style>
